import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 26px;
  ${mq(576)} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SearchLabel = styled.h5`
  font-size: ${({ theme }) => theme.fontsizes.h5};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  white-space: nowrap;
  margin-right: 12px;
  & + div {
    max-width: 718.21px;
    margin: 0;
  }
  ${mq(576)} {
    margin-bottom: 16px;
  }
`;

export const ProductList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /* justify-content: center; */
`;
